import React from "react";
import { graphql, Link } from "gatsby";
import rehypeReact from "rehype-react";
import styled from "styled-components";
import {
  FlexContainer,
  FlexCenteringSpacer
} from "storybook-components/Container";
import SeoHelmet from "../components/SeoHelmet";
import HelpContent from "../components/HelpContent";
import Layout from "../components/Layout";
import SideNav from "../components/SideNav/HelpNav";
import MainContainer from "../components/Shared/MainContainer";
import TableOfContents from "../components/SideNav/TableOfContents";
import {
  Code,
  Strong,
  Li,
  Paragraph,
  H2,
  H3,
  H4,
  PreWithHighlights,
  SmallHeading,
  Table,
  Td,
  Th,
  Highlight,
  Image,
  Video,
  VideoContainer
} from "../components/MarkdownContentComponents";

import {
  ArticleFeedback,
  SupportedLibrariesTable,
  WhiteLabelEmbedTester,
  CodeTabsNotebook,
  CodeTabsWleEmbedUrl,
  CodeTabsWleSignature
} from "../components/StatefulContentComponents";

// eslint-disable-next-line
const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    "gatsby-link": Link,
    p: Paragraph,
    li: Li,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: SmallHeading,
    h6: SmallHeading,
    strong: Strong,
    code: Code,
    pre: PreWithHighlights,
    table: Table,
    td: Td,
    th: Th,
    img: Image,
    vid: Video,
    vidcon: VideoContainer,
    highlight: Highlight,
    "supported-libraries-table": SupportedLibrariesTable,
    "wle-tester": WhiteLabelEmbedTester,
    "code-tabs-wle-signature": CodeTabsWleSignature,
    "code-tabs-wle-embed-url": CodeTabsWleEmbedUrl,
    "code-tabs-notebook": CodeTabsNotebook
  }
}).Compiler;

const HelpContentContainer = styled.div`
  ${({ theme }) => theme.media.desktopUp`
    margin-right: calc(0%);
  `};
`;

export default function Template({ data, pageContext }) {
  const { markdownRemark } = data;
  const currentCategoryName = pageContext.categoryGroups[0][0].categories[0];
  const ToC = markdownRemark && markdownRemark?.headings ? <TableOfContents headings={markdownRemark.headings} /> : '';
  return (
    <Layout className="tutorial-template-container" fluid>
      {markdownRemark && <SeoHelmet
        pathname={markdownRemark?.frontmatter?.path}
        title={markdownRemark?.frontmatter?.title}
        category={currentCategoryName}
        ogdescription={markdownRemark?.frontmatter?.ogdescription}
        ogimage={markdownRemark?.frontmatter?.ogimage}
      />}
      <FlexContainer>
        <SideNav
          className="side-nav"
          currentTutorial={markdownRemark?.frontmatter?.title}
          currentCategory={currentCategoryName}
          toc={ToC}
        />
        <MainContainer>
          <HelpContentContainer>
            {markdownRemark?.htmlAst && <HelpContent
              title={markdownRemark?.frontmatter?.title}
              htmlAst={renderAst(markdownRemark?.htmlAst)}
            />}
            <ArticleFeedback />
          </HelpContentContainer>
        </MainContainer>
        <FlexCenteringSpacer />
      </FlexContainer>
    </Layout>
  );
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        title
        categories
        categories_weight
        ogdescription
        path
        date
      }
      headings {
        value
        depth
        id
      }
    }
  }
`;
